export enum LeaveModalAction {
    Yes,
    No,
    Close
}
